export enum RolModuleEnum {
  Reseller = 'reseller',
  Account = 'account',
  Store = 'store',
  Role = 'rol',
  User = 'usuario',
  Apk = 'apk',
  DelimiterSetting = 'delimiter-setting',
}